/**
 * EmptyState — shared empty-list placeholder for Settings pages.
 *
 * Usage:
 *   <EmptyState
 *     icon={<AppWindow className="w-7 h-7 text-[#265DF5] dark:text-[#5DC9F0]" />}
 *     title="No apps registered yet"
 *     description="Register your first app to start connecting external services to Photon AI."
 *     action={{ label: "Register App", onClick: () => setShowRegister(true) }}
 *   />
 *
 * Props:
 *   icon        – React node rendered inside the icon circle
 *   title       – Bold heading text
 *   description – Supporting subtext (keep to 1-2 lines)
 *   action      – Optional { label, onClick } — renders a primary CTA button
 *   actionNode  – Optional React node rendered in place of the action button (e.g. a dropdown)
 */
import { PrimaryButton } from "../Button/Buttons";

const EmptyState = ({ icon, title, description, action, actionNode, className }) => (
  <div className={`flex flex-col items-center justify-center text-center ${className ?? "py-20"}`}>
    {icon && (
      <div className="w-14 h-14 rounded-full bg-fill-indigo-50 dark:bg-fill-hex-2d3557 flex items-center justify-center mb-4">
        {icon}
      </div>
    )}
    {title && (
      <h3 className="text-sm font-semibold text-ink-ink dark:text-ink-white mb-1">
        {title}
      </h3>
    )}
    {description && (
      <p className="text-xs text-ink-gray-500 dark:text-ink-gray-400 max-w-xs leading-5 mb-4">
        {description}
      </p>
    )}
    {actionNode ?? (action && (
      <PrimaryButton onClick={action.onClick}>
        {action.label}
      </PrimaryButton>
    ))}
  </div>
);

export default EmptyState;
